import { type ReactNode, useMemo } from "react";
import { Router } from "react-router-dom";

import { createAppRouterHistory, type IAppRouterHistoryOptions } from "./createAppRouterHistory";

export interface IAppRouterProps extends IAppRouterHistoryOptions {
    children: ReactNode;
}

/**
 * Router component that integrates with mobile webview navigation.
 *
 * In webview context:
 * - Emits navigation events BEFORE routing (not after)
 * - Handles back navigation at root by delegating to native `onGoBack()`
 *
 * Outside webview: Behaves like standard BrowserRouter.
 *
 * @example
 * ```tsx
 * <AppRouter basename="/app">
 *   <Routes />
 * </AppRouter>
 * ```
 */
export const AppRouter: React.FC<IAppRouterProps> = ({ children, basename }) => {
    const history = useMemo(() => createAppRouterHistory({ basename }), [basename]);

    return <Router history={history}>{children}</Router>;
};
